// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2VbRs","alert":"SettungsInbox_alert__3f7Jz"};